import React, { Fragment, useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { reduxBatch } from '@manaflair/redux-batch'

import { uiActions } from '../store/slices'

import { PageView, DesktopView, TabletView, MobileView } from '../containers'
import { Responsive } from '../../../containers'

import queryString from 'query-string'
import { InlineManualService } from '../../../utils/services'

const App = () => {
  const dispatch = useDispatch()

  const params = queryString.parse(window.location.search) ?? {}

  useEffect(() => {
    if (params.source === 'EC') {
      document.documentElement.classList.add('-customerPortal')

      // if (params.requestedCountry) {
      //   const stateByCountry = getStateByCountry(params.requestedCountry, connectionType)

      //   reduxBatch([
      //     dispatch(settingsActions.updateInput(stateByCountry.setting)),
      //     dispatch(jobSettingsActions.updateInput(stateByCountry.jobSettings)),
      //   ])
      // }
    }

    reduxBatch([
      dispatch(uiActions.modifyUIState({ name: 'ecMode', value: params.source === 'EC' })),
      dispatch(uiActions.fetchUIInitialization()),
    ])
  }, [params])

  InlineManualService.enablePeopleTracking()

  return (
    <Fragment>
      <PageView>
        <Responsive.Desktop>
          <DesktopView />
        </Responsive.Desktop>
        <Responsive.Tablet>
          <TabletView />
        </Responsive.Tablet>
        <Responsive.Mobile>
          <MobileView />
        </Responsive.Mobile>
      </PageView>
    </Fragment>
  )
}

export default App
